var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-avatar flex align-center justify-center",style:({width: _vm.renderSize, height: _vm.renderSize})},[(_vm.$slots.default)?_c('div',{style:({fontSize: _vm.renderFontSize})},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }